import { Slide, toast } from 'react-toastify';
import { ToastMessageType } from '../types/ToastMessageType';

/**
 * Safely shows a toast message based on the message type.
 * Falls back to 'success' if the message type is invalid or not provided.
 * @param message - The message to display
 * @param messageType - The type of message (success, error, warning)
 */
export function showToastMessage(
  message: string,
  messageType: string | null | undefined,
): void {
  const validType: ToastMessageType =
    messageType === 'error' || messageType === 'warning'
      ? messageType
      : 'success';

  switch (validType) {
    case 'error':
      showErrorMessage(message);
      break;
    case 'warning':
      showWarningMessage(message);
      break;
    case 'success':
    default:
      showSuccessMessage(message);
      break;
  }
}

export function showSuccessMessage(message: string) {
  toast.success(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Slide,
  });
}

export function showErrorMessage(message: string) {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Slide,
  });
}

export function showWarningMessage(message: string) {
  toast.warn(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Slide,
  });
}
